export default class LqRealTimeService{
    constructor(http){
        this.http = http
    }

    fetchMixplantList(workAreaId,timeRange){
        var ran  = Math.random()*10;//随机数
        return this.http.get('/lq/mixplant/realTimeMixplant',{id:workAreaId,timeRange,ran})
            .then(res=>res.data);
    }

    fetchLabelDashBoard(terms){
        return this.http.get('/lq/mixplant/keyLabel',terms)
            .then(res=>res.data);
    }

    fetchRealTimeOutput(terms){
        return this.http.get('/lq/mixplant/realTimeOutput',terms)
            .then(res=>res.data);
    }
}
LqRealTimeService.$inject = ['http']